import React from 'react';
import {Form} from 'semantic-ui-react';
import {
  Checkbox,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import SpanText from 'app-ui-componentlibrary/dist/go/components/common/form/SpanText';
import _ from 'lodash';
import {Alert} from 'componentLibrary';
import {isLoginGovUser, isFemaUser} from 'common/utils';

export class AuthSubmitWrapper extends React.Component {
  state = {
    password: '',
    authError: [],
  };

  handleSubmit = (payload) => {
    const password = this.state.password;
    return this.props
      .handleSubmit(payload, password)
      .then(
        (res) => {
          let authErrors = [];
          if (res.errors) {
            const errors = _.map(res.errors, (err) => err.text);
            authErrors = errors;
          }
          if (res.status === 403) {
            let message = this.props.invalidPasswordMessage
              ? this.props.invalidPasswordMessage
              : 'The application was not submitted because of an invalid password.';
            authErrors.push(message);
          }
          this.setState({
            authError: authErrors,
            password: '',
          });
          return res;
        },
        (err) => {
          console.error('Error while submitting');
        }
      )
      .catch((err) => {
        console.error('Caugth error while submitting');
      });
  };

  render() {
    const {confirmationLabel, content, errorAlertHeader} = this.props;
    const {password, confirmation, authError} = this.state;
    const loginGovIntegration = isLoginGovUser();
    const internalUserIntegration = isFemaUser(this.props.permissions);
    const isValid = (internalUserIntegration || loginGovIntegration || !_.isEmpty(password)) && !!confirmation;
    let confirmationLabelReplaced = loginGovIntegration || internalUserIntegration
      ? _.replace(confirmationLabel, 'entering my password', 'checking this box')
      : confirmationLabel;
    confirmationLabelReplaced = loginGovIntegration
      ? _.replace(
          confirmationLabelReplaced,
          'signing this subapplication',
          'checking this box'
        )
      : confirmationLabelReplaced;
    return (
      <Form id="submission-signature-form">
        {content ? (
          <React.Fragment>
            <SpanText value={content} />
            <br />
            <br />
          </React.Fragment>
        ) : (
          <React.Fragment />
        )}
        <Checkbox
          label={confirmationLabelReplaced}
          checked={!!confirmation}
          handleChange={(name, value) => this.setState({confirmation: !!value})}
        />
        {!loginGovIntegration && !internalUserIntegration &&(
          <TextBoxField
            id="password"
            name="password"
            value={password}
            handleChange={(e, data) => this.setState({password: data.value})}
            title="Password"
            type="password"
            size="small"
            label="Please enter your password."
          />
        )}
        {!_.isEmpty(authError) && (
          <Alert alertType="error" header={errorAlertHeader || 'Unable to submit'}>
            <p>The request cannot be submitted due to the following:</p>
            <ul>
              {_.map(authError, (err) => (
                <li>{err}</li>
              ))}
            </ul>
          </Alert>
        )}
        {this.props.children(this.handleSubmit, isValid)}
      </Form>
    );
  }
}

export default AuthSubmitWrapper;
